export const prelandingScreenButton = `w-full max-w-[135px] my-0 m-auto`
export const prelandingScreenWrapper = `max-w-[992px] p-8 sm:p-0`
export const prelandingScreenBorder = `sm:p-8 flex flex-col sm:flex-row justify-center sm:border-solid sm:border-2 rounded md:justify-around`
export const prelandingScreenStep = `flex flex-col w-full justify-center sm:w-5/12`
export const prelandingScreenImg = `w-11/12 sm:w-10/12 sm:h-5/12 border-2 border-[#243c5a]`
export const prelandingScreenParagraph = `my-4 text-center text-base sm:text-xl`